import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    searchOpen: false,
    navOpen: false,
    drawerOpen: false,
    searchQuery: "",
    topAlertActive: false,
    bottomAlertActive: false,
    reduceMotion: matchMedia('(prefers-reduced-motion)').matches
  },
  mutations: {
    setQuery(state) {
      if (Object.keys(router.currentRoute.query).length !== 0) {
        if (router.currentRoute.query.s) {
          state.searchQuery = router.currentRoute.query.s;
        } else {
          state.searchQuery = "";
        }
      }
    },
    setTopAlertActive(state, payload) {
      state.topAlertActive = payload;
    },
    setBottomAlertActive(state, payload) {
      state.bottomAlertActive = payload;
    },
    setDrawerOpen(state, payload) {
      state.drawerOpen = payload;
    }
  },
  actions: {
    setQuery({ commit }) {
      commit("setQuery");
    },
  },
});
